import Vue from 'vue';
import axios, { AxiosResponse } from 'axios';
import VueAxios from 'vue-axios';
import { API_URL } from '../config';
import errorModule from '../../store/modules/error.module';
import { HttpErrorMessage } from '../enum';
import JwtService, { ID_ACCESS_TOKEN_KEY } from '../jwt.service';

class ApiServiceAPI {
  constructor() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
    const jwtService = new JwtService();
    const authToken = jwtService.getToken(ID_ACCESS_TOKEN_KEY)
    if (authToken) {
      this.setHeader(authToken);
    }
  }

  setHeader(token: string): void {
    Vue.axios.defaults.headers.common.Authorization = `${token}`;
  }

  async get(resource: string, params = {}): Promise<AxiosResponse | undefined> {
    try {
      errorModule.setLoading(true);
      console.log({ params });
      const response = await Vue.axios.get(`${API_URL}${resource}`, { params });
      errorModule.setLoading(false);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
      errorModule.setLoading(false);
      if (error.response) {
        errorModule.throwError(error.response.data.message)
        console.error(`[ERROR] ApiService ${error.response.data.message}`);
        return;
      }
      errorModule.throwError(HttpErrorMessage.GenericError)
    }
  }

  async post(
    resource: string,
    params = {},
  ): Promise<AxiosResponse | undefined> {
    try {
      errorModule.setLoading(true);
      const response = await Vue.axios.post(API_URL + resource, params);
      errorModule.setLoading(false);
      console.log(response);
      return response;
    } catch (error) {
      console.log(error);
      errorModule.setLoading(false);
      console.log(JSON.stringify(error.response.data.message));
      errorModule.throwError(error.response.data.message)
      console.log(`[ERROR] ApiService ${error.response.data}`);
    }
  }

  async put(resource: string, params = {}): Promise<AxiosResponse | undefined> {
    try {
      errorModule.setLoading(true);
      const token = Vue.axios.defaults.headers.common.Authorization;
      delete axios.defaults.headers.common.Authorization;
      const response = await axios.put(`${resource}`, params, {
        headers: { 'Content-Type': '' },
      });
      errorModule.setLoading(false);
      axios.defaults.headers.common.Authorization = `${token}`;
      console.log(response);
      return response;
    } catch (error) {
      errorModule.setLoading(false);
      errorModule.throwError(HttpErrorMessage.GenericError)
      console.log(`[ERROR] ApiService ${error.response.data}`);
    }
  }

  async delete(resource: string, data = {}): Promise<AxiosResponse | undefined> {
    try {
      errorModule.setLoading(true);
      const response = await Vue.axios.delete(resource, { data });
      errorModule.setLoading(false);
      console.log(response);
      return response;
    } catch (error) {
      errorModule.setLoading(false);
      errorModule.throwError(HttpErrorMessage.GenericError)
      console.log(`[ERROR] ApiService ${error}`);
    }
  }

  checkStatusCode(response) {
    if (response && response.status) {
      return response.status >= 200 && response.status < 300;
    }
    return false;
  }
}

export default ApiServiceAPI;
